import React from "react";
import { Offcanvas } from "react-bootstrap";
import ICart_Item from "@models/ICart_Item";
import OwS3ImageViewer from "@components/shared/OwS3ImageViewer/OwS3ImageViewer";
import IImageSizeEnum from "@models/IImageSizeEnum";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwButton from "@components/shared/OwButton/OwButton";
import "./MobileCartNotification.scss";

type Props = {
    show: boolean;
    cartItem: ICart_Item | null;
    onClose: () => void;
    onViewCart: () => void;
};

export const MobileCartNotification: React.FC<Props> = (props) => {
    const { show, cartItem, onClose, onViewCart } = props;

    if (!cartItem) {
        return null;
    }

    return (
        <Offcanvas show={show} onHide={onClose} placement="bottom" className="MobileCartNotification">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                    <OwLabel title="item_added_to_cart" />
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="notification-content">
                    <div className="product-image">
                        <OwS3ImageViewer
                            catalogItem={cartItem.Catalog_Item}
                            isMicroView={true}
                            attachmentIndex={0}
                            imageIndex={IImageSizeEnum.THUMB}
                            className="w-5r h-5r"
                            includeAllImages={true}
                            hideEmptyImage={false}
                        />
                    </div>
                    <div className="product-info">
                        <div className="product-name">{cartItem.Catalog_Item?.name}</div>
                        <div className="product-sku text-muted">{cartItem.Catalog_Item?.sku}</div>
                        <div className="product-qty">
                            <OwLabel title="qty" postText=":" /> {cartItem.qty}
                        </div>
                    </div>
                </div>
                <div className="notification-actions">
                    <OwButton btnSizeClass="btn-lg" fn={onViewCart} title="view_cart" className="btn-primary w-100" />
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default MobileCartNotification;
